"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _Radio = _interopRequireDefault(require("../../elements/Radio"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * A group of radio boxes, providing a single value based on checked state.
 *
 * Options are provided as:
 *
 * <pre>
 *  [
 *      {label: 'Label 1', value: 'value'},
 *      ...
 *  ]
 * </pre>
 */


var RadioGroup = function RadioGroup(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      options = _ref.options,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["name", "value", "className", "options", "onChange"]);

  return _react.default.createElement("div", {
    className: "Fulcrum RadioGroup ".concat(className)
  }, (0, _lodash.map)(options, function (option, index) {
    return _react.default.createElement(_Radio.default, _extends({
      key: index
    }, props, {
      label: option.label,
      name: name,
      value: option.value,
      checked: option.value === value,
      onChange: onChange
    }));
  }));
};

var _default = RadioGroup;
exports.default = _default;